var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, IconButton, Link as MuiLink, Stack, TableBody, TableCell, TableRow, TextField, Typography } from '@mui/material';
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { TABLE_HIERARCHY_COLORS } from '../../../enum';
import { formatNumberByLocale } from '../../../util';
import { Autocomplete, ConfirmDialog, ErrorMessageBox, FallbackComponent, NumberInput, UnControlledFormField } from '../../common';
import { ExpandableRowLabel, TABLE_HIERARCHY_INDENTS } from '../../common/tableHierarchy';
import { useDialog } from '../../hooks';
import { useClientLobsAPI, useClientsAPI } from '../clients/selectors';
import { WizardTable } from '../common/WizardTable';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { waitForApiSliceTerminal } from '../common/waitForApiSliceTerminal';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useLocationsAPI } from '../selectors';
import { SeatAllocationModal } from './SeatAllocationModal';
import { MAX_ALLOCATED_SEATS, MIN_ALLOCATED_SEATS, useBatchCreateSeatAllocationAPI, useBatchDeleteSeatAllocationAPI, useSeatAllocationsByClientAPI, useSeatAllocationsByLocationAPI, useSeatsCapacityAPI } from './selectors';
function toggleSetItem(setter, key) {
  setter(function (s) {
    var next = new Set(s);
    next.has(key) ? next.delete(key) : next.add(key);
    return next;
  });
}
function addItemsToSet(items, newItems) {
  return new Set(__spreadArray(__spreadArray([], Array.from(items), true), newItems, true));
}
var DialogMode;
(function (DialogMode) {
  DialogMode["EditClient"] = "EditClient";
})(DialogMode || (DialogMode = {}));
function LocationTypeLabel(_a) {
  var _b;
  var locationType = _a.locationType;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'seats'
  }).t;
  var map = {
    in_house: t('locationType.inHouse', {
      defaultValue: 'In-House'
    }),
    outsourced: t('locationType.outsourced', {
      defaultValue: 'Outsourced'
    })
  };
  return _jsx(_Fragment, {
    children: (_b = map[locationType]) !== null && _b !== void 0 ? _b : locationType
  });
}
function DeleteSiteButton(_a) {
  var allocationIds = _a.allocationIds,
    onDelete = _a.onDelete;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'seats'
  }).t;
  return _jsx(IconButton, __assign({
    size: "small",
    onClick: function () {
      return onDelete(allocationIds);
    },
    disabled: allocationIds.length === 0,
    "aria-label": t('deleteSeatInventory', {
      defaultValue: 'Delete seat inventory entry'
    }),
    sx: {
      color: function (theme) {
        return theme.palette.text.primary;
      },
      '&:hover': {
        color: function (theme) {
          return theme.palette.text.primary;
        },
        backgroundColor: function (theme) {
          return theme.palette.action.hover;
        }
      }
    }
  }, {
    children: _jsx(FontAwesomeIcon, {
      icon: "trash-can"
    })
  }));
}
var formatBufferPercent = function (value) {
  return "".concat(formatNumberByLocale(value !== null && value !== void 0 ? value : 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }), "%");
};
var SEAT_EXPANSION_KEY_SEPARATOR = ':';
var getSeatExpansionKey = function () {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  return parts.join(SEAT_EXPANSION_KEY_SEPARATOR);
};
var splitSeatExpansionKey = function (key) {
  return key.split(SEAT_EXPANSION_KEY_SEPARATOR);
};
function createByClientExpansionFocusKeys() {
  return {
    focusLobKeys: new Set(),
    focusTypeKeys: new Set(),
    focusLocationKeys: new Set(),
    allLobKeys: [],
    allTypeKeys: [],
    allLocationKeys: []
  };
}
function hasFocusedSeatAllocation(allocations, clientId, lobId, locationId) {
  return allocations.some(function (allocation) {
    return allocation.clientId === clientId && allocation.lobId === lobId && allocation.locationId === locationId;
  });
}
function addByClientFocusedKeys(keys, allocations, context) {
  var clientId = context.clientId,
    lobId = context.lobId,
    locationId = context.locationId,
    lobKey = context.lobKey,
    typeKey = context.typeKey,
    locKey = context.locKey;
  if (hasFocusedSeatAllocation(allocations, clientId, lobId, locationId)) {
    keys.focusLobKeys.add(lobKey);
    keys.focusTypeKeys.add(typeKey);
    keys.focusLocationKeys.add(locKey);
  }
}
function buildByClientExpansionFocusKeys(rows, allocations) {
  var keys = createByClientExpansionFocusKeys();
  for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
    var client = rows_1[_i];
    for (var _a = 0, _b = client.lobs; _a < _b.length; _a++) {
      var lob = _b[_a];
      var lobKey = getSeatExpansionKey(client.clientId, lob.lobId);
      keys.allLobKeys.push(lobKey);
      for (var _c = 0, _d = lob.locationTypes; _c < _d.length; _c++) {
        var typeGroup = _d[_c];
        var typeKey = getSeatExpansionKey(lobKey, typeGroup.locationType);
        keys.allTypeKeys.push(typeKey);
        for (var _e = 0, _f = typeGroup.locations; _e < _f.length; _e++) {
          var loc = _f[_e];
          var locKey = getSeatExpansionKey(typeKey, loc.locationId);
          keys.allLocationKeys.push(locKey);
          addByClientFocusedKeys(keys, allocations, {
            clientId: client.clientId,
            lobId: lob.lobId,
            locationId: loc.locationId,
            lobKey: lobKey,
            typeKey: typeKey,
            locKey: locKey
          });
        }
      }
    }
  }
  return keys;
}
function ByClientInventory(_a) {
  var rows = _a.rows,
    onEditClient = _a.onEditClient,
    onDeleteSite = _a.onDeleteSite,
    expansionFocus = _a.expansionFocus;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'seats'
  }).t;
  var initialExpansionKeys = buildByClientExpansionFocusKeys(rows, []);
  var _b = useState(new Set()),
    collapsedClients = _b[0],
    setCollapsedClients = _b[1];
  var _c = useState(function () {
      return new Set(initialExpansionKeys.allLobKeys);
    }),
    collapsedLobs = _c[0],
    setCollapsedLobs = _c[1];
  var _d = useState(function () {
      return new Set(initialExpansionKeys.allTypeKeys);
    }),
    collapsedTypes = _d[0],
    setCollapsedTypes = _d[1];
  var _e = useState(function () {
      return new Set(initialExpansionKeys.allLocationKeys);
    }),
    collapsedLocations = _e[0],
    setCollapsedLocations = _e[1];
  var initializedExpansionStateRef = useRef(rows.length > 0);
  var appliedExpansionFocusVersionRef = useRef(0);
  var getClientNestedExpansionKeys = function (clientId) {
    var _a;
    var client = rows.find(function (row) {
      return row.clientId === clientId;
    });
    var lobKeys = [];
    var typeKeys = [];
    var locationKeys = [];
    for (var _i = 0, _b = (_a = client === null || client === void 0 ? void 0 : client.lobs) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++) {
      var lob = _b[_i];
      var lobKey = getSeatExpansionKey(clientId, lob.lobId);
      lobKeys.push(lobKey);
      for (var _c = 0, _d = lob.locationTypes; _c < _d.length; _c++) {
        var typeGroup = _d[_c];
        var typeKey = getSeatExpansionKey(lobKey, typeGroup.locationType);
        typeKeys.push(typeKey);
        for (var _e = 0, _f = typeGroup.locations; _e < _f.length; _e++) {
          var loc = _f[_e];
          locationKeys.push(getSeatExpansionKey(typeKey, loc.locationId));
        }
      }
    }
    return {
      lobKeys: lobKeys,
      typeKeys: typeKeys,
      locationKeys: locationKeys
    };
  };
  var getLobNestedExpansionKeys = function (lobKey) {
    var _a, _b;
    var _c = splitSeatExpansionKey(lobKey).map(Number),
      clientId = _c[0],
      lobId = _c[1];
    var lob = (_a = rows.find(function (row) {
      return row.clientId === clientId;
    })) === null || _a === void 0 ? void 0 : _a.lobs.find(function (item) {
      return item.lobId === lobId;
    });
    var typeKeys = [];
    var locationKeys = [];
    for (var _i = 0, _d = (_b = lob === null || lob === void 0 ? void 0 : lob.locationTypes) !== null && _b !== void 0 ? _b : []; _i < _d.length; _i++) {
      var typeGroup = _d[_i];
      var typeKey = getSeatExpansionKey(lobKey, typeGroup.locationType);
      typeKeys.push(typeKey);
      for (var _e = 0, _f = typeGroup.locations; _e < _f.length; _e++) {
        var loc = _f[_e];
        locationKeys.push(getSeatExpansionKey(typeKey, loc.locationId));
      }
    }
    return {
      typeKeys: typeKeys,
      locationKeys: locationKeys
    };
  };
  var getTypeNestedExpansionKeys = function (typeKey) {
    var _a, _b, _c;
    var _d = splitSeatExpansionKey(typeKey),
      clientIdText = _d[0],
      lobIdText = _d[1],
      locationTypeParts = _d.slice(2);
    var clientId = Number(clientIdText);
    var lobId = Number(lobIdText);
    var locationType = locationTypeParts.join(SEAT_EXPANSION_KEY_SEPARATOR);
    var typeGroup = (_b = (_a = rows.find(function (row) {
      return row.clientId === clientId;
    })) === null || _a === void 0 ? void 0 : _a.lobs.find(function (lob) {
      return lob.lobId === lobId;
    })) === null || _b === void 0 ? void 0 : _b.locationTypes.find(function (item) {
      return item.locationType === locationType;
    });
    return (_c = typeGroup === null || typeGroup === void 0 ? void 0 : typeGroup.locations.map(function (loc) {
      return getSeatExpansionKey(typeKey, loc.locationId);
    })) !== null && _c !== void 0 ? _c : [];
  };
  useEffect(function () {
    if (initializedExpansionStateRef.current || rows.length === 0) return;
    var _a = buildByClientExpansionFocusKeys(rows, []),
      allLobKeys = _a.allLobKeys,
      allTypeKeys = _a.allTypeKeys,
      allLocationKeys = _a.allLocationKeys;
    initializedExpansionStateRef.current = true;
    setCollapsedLobs(new Set(allLobKeys));
    setCollapsedTypes(new Set(allTypeKeys));
    setCollapsedLocations(new Set(allLocationKeys));
  }, [rows]);
  useEffect(function () {
    if (!(expansionFocus === null || expansionFocus === void 0 ? void 0 : expansionFocus.version)) return;
    if (appliedExpansionFocusVersionRef.current === expansionFocus.version) return;
    var focusClientIds = new Set(expansionFocus.allocations.map(function (allocation) {
      return allocation.clientId;
    }));
    var _a = buildByClientExpansionFocusKeys(rows, expansionFocus.allocations),
      focusLobKeys = _a.focusLobKeys,
      focusTypeKeys = _a.focusTypeKeys,
      focusLocationKeys = _a.focusLocationKeys,
      allLobKeys = _a.allLobKeys,
      allTypeKeys = _a.allTypeKeys,
      allLocationKeys = _a.allLocationKeys;
    if (focusLocationKeys.size === 0) return;
    appliedExpansionFocusVersionRef.current = expansionFocus.version;
    setCollapsedClients(new Set(rows.filter(function (row) {
      return !focusClientIds.has(row.clientId);
    }).map(function (row) {
      return row.clientId;
    })));
    setCollapsedLobs(new Set(allLobKeys.filter(function (key) {
      return !focusLobKeys.has(key);
    })));
    setCollapsedTypes(new Set(allTypeKeys.filter(function (key) {
      return !focusTypeKeys.has(key);
    })));
    setCollapsedLocations(new Set(allLocationKeys.filter(function (key) {
      return !focusLocationKeys.has(key);
    })));
  }, [expansionFocus, rows]);
  var toggleClient = function (clientId) {
    var wasCollapsed = collapsedClients.has(clientId);
    setCollapsedClients(function (prev) {
      var next = new Set(prev);
      next.has(clientId) ? next.delete(clientId) : next.add(clientId);
      return next;
    });
    if (wasCollapsed) {
      var nestedExpansionKeys_1 = getClientNestedExpansionKeys(clientId);
      setCollapsedLobs(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_1.lobKeys);
      });
      setCollapsedTypes(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_1.typeKeys);
      });
      setCollapsedLocations(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_1.locationKeys);
      });
    }
  };
  var toggleLob = function (lobKey) {
    var wasCollapsed = collapsedLobs.has(lobKey);
    setCollapsedLobs(function (prev) {
      var next = new Set(prev);
      next.has(lobKey) ? next.delete(lobKey) : next.add(lobKey);
      return next;
    });
    if (wasCollapsed) {
      var nestedExpansionKeys_2 = getLobNestedExpansionKeys(lobKey);
      setCollapsedTypes(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_2.typeKeys);
      });
      setCollapsedLocations(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_2.locationKeys);
      });
    }
  };
  var toggleType = function (typeKey) {
    var wasCollapsed = collapsedTypes.has(typeKey);
    setCollapsedTypes(function (prev) {
      var next = new Set(prev);
      next.has(typeKey) ? next.delete(typeKey) : next.add(typeKey);
      return next;
    });
    if (wasCollapsed) {
      setCollapsedLocations(function (prev) {
        return addItemsToSet(prev, getTypeNestedExpansionKeys(typeKey));
      });
    }
  };
  var renderClientLocRow = function (typeKey, loc) {
    var _a;
    var locKey = getSeatExpansionKey(typeKey, loc.locationId);
    var locExpanded = !collapsedLocations.has(locKey);
    var hasSubLobs = loc.subLobs.some(function (s) {
      return s.subLobId !== null;
    });
    var singleBuffer = (_a = loc.subLobs[0]) === null || _a === void 0 ? void 0 : _a.bufferPercent;
    var singleBufferLabel = formatBufferPercent(singleBuffer);
    var bufferCell = hasSubLobs ? '' : singleBufferLabel;
    return _jsxs(Fragment, {
      children: [_jsxs(TableRow, {
        children: [_jsx(TableCell, __assign({
          sx: {
            pl: TABLE_HIERARCHY_INDENTS[4]
          }
        }, {
          children: _jsx(ExpandableRowLabel, __assign({
            expanded: locExpanded,
            onToggle: hasSubLobs ? function () {
              return toggleSetItem(setCollapsedLocations, locKey);
            } : undefined
          }, {
            children: loc.locationName
          }))
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: formatNumberByLocale(loc.reservedSeats)
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: bufferCell
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: _jsx(DeleteSiteButton, {
            allocationIds: loc.subLobs.map(function (s) {
              return s.allocationId;
            }),
            onDelete: onDeleteSite
          })
        }))]
      }), hasSubLobs && locExpanded && loc.subLobs.map(function (subLob) {
        var _a;
        return _jsxs(TableRow, {
          children: [_jsx(TableCell, __assign({
            sx: {
              pl: TABLE_HIERARCHY_INDENTS[5]
            }
          }, {
            children: (_a = subLob.subLobName) !== null && _a !== void 0 ? _a : t('noSubLob', {
              defaultValue: '(No sub-line of business)'
            })
          })), _jsx(TableCell, __assign({
            align: "center"
          }, {
            children: formatNumberByLocale(subLob.reservedSeats)
          })), _jsx(TableCell, __assign({
            align: "center"
          }, {
            children: formatBufferPercent(subLob.bufferPercent)
          })), _jsx(TableCell, {})]
        }, getSeatExpansionKey(locKey, 'sub', subLob.allocationId));
      })]
    }, locKey);
  };
  var renderLobTypeGroup = function (lobKey, typeGroup) {
    var typeKey = getSeatExpansionKey(lobKey, typeGroup.locationType);
    var typeExpanded = !collapsedTypes.has(typeKey);
    var hasLocations = typeGroup.locations.length > 0;
    return _jsxs(Fragment, {
      children: [_jsxs(TableRow, __assign({
        sx: {
          bgcolor: TABLE_HIERARCHY_COLORS.lightGray
        }
      }, {
        children: [_jsx(TableCell, __assign({
          sx: {
            pl: TABLE_HIERARCHY_INDENTS[3]
          }
        }, {
          children: _jsx(ExpandableRowLabel, __assign({
            expanded: typeExpanded,
            onToggle: hasLocations ? function () {
              return toggleType(typeKey);
            } : undefined
          }, {
            children: _jsx(LocationTypeLabel, {
              locationType: typeGroup.locationType
            })
          }))
        })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {})]
      })), typeExpanded && typeGroup.locations.map(function (loc) {
        return renderClientLocRow(typeKey, loc);
      })]
    }, typeKey);
  };
  if (!rows.length) {
    return _jsx(TableRow, {
      children: _jsx(TableCell, __assign({
        colSpan: 4,
        align: "center",
        sx: {
          color: 'text.secondary',
          py: 4
        }
      }, {
        children: t('noData', {
          defaultValue: 'No data to display'
        })
      }))
    });
  }
  return _jsx(_Fragment, {
    children: rows.map(function (client) {
      var clientExpanded = !collapsedClients.has(client.clientId);
      return _jsxs(Fragment, {
        children: [_jsxs(TableRow, __assign({
          sx: {
            bgcolor: TABLE_HIERARCHY_COLORS.lightBlue
          }
        }, {
          children: [_jsx(TableCell, __assign({
            sx: {
              pl: TABLE_HIERARCHY_INDENTS[1],
              fontWeight: 'bold'
            }
          }, {
            children: _jsx(ExpandableRowLabel, __assign({
              expanded: clientExpanded,
              onToggle: function () {
                return toggleClient(client.clientId);
              },
              bold: true
            }, {
              children: _jsx(MuiLink, __assign({
                component: "button",
                sx: {
                  fontWeight: 'bold'
                },
                onClick: function (e) {
                  e.stopPropagation();
                  onEditClient(client.clientId);
                }
              }, {
                children: client.clientName
              }))
            }))
          })), _jsx(TableCell, __assign({
            align: "center",
            sx: {
              fontWeight: 'bold'
            }
          }, {
            children: formatNumberByLocale(client.reservedSeats)
          })), _jsx(TableCell, {}), _jsx(TableCell, {})]
        }), "client-".concat(client.clientId)), clientExpanded && client.lobs.map(function (lob) {
          var lobKey = getSeatExpansionKey(client.clientId, lob.lobId);
          var lobExpanded = !collapsedLobs.has(lobKey);
          var hasTypes = lob.locationTypes.length > 0;
          return _jsxs(Fragment, {
            children: [_jsxs(TableRow, __assign({
              sx: {
                bgcolor: TABLE_HIERARCHY_COLORS.lightBlueGray
              }
            }, {
              children: [_jsx(TableCell, __assign({
                sx: {
                  pl: TABLE_HIERARCHY_INDENTS[2]
                }
              }, {
                children: _jsx(ExpandableRowLabel, __assign({
                  expanded: lobExpanded,
                  onToggle: hasTypes ? function () {
                    return toggleLob(lobKey);
                  } : undefined
                }, {
                  children: lob.lobName
                }))
              })), _jsx(TableCell, __assign({
                align: "center"
              }, {
                children: formatNumberByLocale(lob.reservedSeats)
              })), _jsx(TableCell, {}), _jsx(TableCell, {})]
            }), lobKey), lobExpanded && lob.locationTypes.map(function (typeGroup) {
              return renderLobTypeGroup(lobKey, typeGroup);
            })]
          }, lobKey);
        })]
      }, "client-".concat(client.clientId));
    })
  });
}
function createByLocationExpansionFocusKeys() {
  return {
    focusTypeKeys: new Set(),
    focusLocationKeys: new Set(),
    focusLobKeys: new Set(),
    allTypeKeys: [],
    allLocationKeys: [],
    allLobKeys: []
  };
}
function addByLocationFocusedKeys(keys, allocations, context) {
  var clientId = context.clientId,
    lobId = context.lobId,
    locationId = context.locationId,
    locKey = context.locKey,
    typeKey = context.typeKey,
    lobKey = context.lobKey;
  if (hasFocusedSeatAllocation(allocations, clientId, lobId, locationId)) {
    keys.focusTypeKeys.add(typeKey);
    keys.focusLocationKeys.add(locKey);
    keys.focusLobKeys.add(lobKey);
  }
}
function buildByLocationExpansionFocusKeys(clientGroups, allocations) {
  var keys = createByLocationExpansionFocusKeys();
  for (var _i = 0, clientGroups_1 = clientGroups; _i < clientGroups_1.length; _i++) {
    var client = clientGroups_1[_i];
    for (var _a = 0, _b = client.typeGroups; _a < _b.length; _a++) {
      var typeGroup = _b[_a];
      var typeKey = getSeatExpansionKey(client.clientId, typeGroup.locationType);
      keys.allTypeKeys.push(typeKey);
      for (var _c = 0, _d = typeGroup.locations; _c < _d.length; _c++) {
        var loc = _d[_c];
        var locKey = getSeatExpansionKey(typeKey, loc.locationId);
        keys.allLocationKeys.push(locKey);
        for (var _e = 0, _f = loc.lobs; _e < _f.length; _e++) {
          var lob = _f[_e];
          var lobKey = getSeatExpansionKey(locKey, lob.lobId);
          keys.allLobKeys.push(lobKey);
          addByLocationFocusedKeys(keys, allocations, {
            clientId: client.clientId,
            lobId: lob.lobId,
            locationId: loc.locationId,
            lobKey: lobKey,
            typeKey: typeKey,
            locKey: locKey
          });
        }
      }
    }
  }
  return keys;
}
export function buildClientGroups(rows) {
  var clientMap = new Map();
  var _loop_1 = function (loc) {
    for (var _a = 0, _b = loc.clients; _a < _b.length; _a++) {
      var client = _b[_a];
      if (!clientMap.has(client.clientId)) {
        clientMap.set(client.clientId, {
          clientId: client.clientId,
          clientName: client.clientName,
          reservedSeats: 0,
          typeGroups: []
        });
      }
      var clientEntry = clientMap.get(client.clientId);
      var typeGroup = clientEntry.typeGroups.find(function (t) {
        return t.locationType === loc.locationType;
      });
      if (!typeGroup) {
        typeGroup = {
          locationType: loc.locationType,
          reservedSeats: 0,
          locations: []
        };
        clientEntry.typeGroups.push(typeGroup);
      }
      var locReserved = client.lobs.reduce(function (sum, l) {
        return sum + l.reservedSeats;
      }, 0);
      typeGroup.locations.push({
        locationId: loc.locationId,
        locationName: loc.locationName,
        totalSeats: loc.totalSeats,
        reservedSeats: locReserved,
        lobs: client.lobs
      });
      typeGroup.reservedSeats += locReserved;
      clientEntry.reservedSeats += locReserved;
    }
  };
  for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
    var loc = rows_2[_i];
    _loop_1(loc);
  }
  return Array.from(clientMap.values()).sort(function (a, b) {
    return a.clientName.localeCompare(b.clientName);
  });
}
function ByLocationInventory(_a) {
  var rows = _a.rows,
    capacity = _a.capacity,
    onEditClient = _a.onEditClient,
    onDeleteSite = _a.onDeleteSite,
    expansionFocus = _a.expansionFocus;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'seats'
  }).t;
  var clientGroups = useMemo(function () {
    return buildClientGroups(rows);
  }, [rows]);
  var initialExpansionKeys = buildByLocationExpansionFocusKeys(clientGroups, []);
  var _b = useState(new Set()),
    collapsedClients = _b[0],
    setCollapsedClients = _b[1];
  var _c = useState(function () {
      return new Set(initialExpansionKeys.allTypeKeys);
    }),
    collapsedTypes = _c[0],
    setCollapsedTypes = _c[1];
  var _d = useState(function () {
      return new Set(initialExpansionKeys.allLocationKeys);
    }),
    collapsedLocations = _d[0],
    setCollapsedLocations = _d[1];
  var _e = useState(function () {
      return new Set(initialExpansionKeys.allLobKeys);
    }),
    collapsedLobLeafs = _e[0],
    setCollapsedLobLeafs = _e[1];
  var initializedExpansionStateRef = useRef(clientGroups.length > 0);
  var appliedExpansionFocusVersionRef = useRef(0);
  var getLocationClientNestedExpansionKeys = function (clientId) {
    var _a;
    var client = clientGroups.find(function (group) {
      return group.clientId === clientId;
    });
    var typeKeys = [];
    var locationKeys = [];
    var lobKeys = [];
    for (var _i = 0, _b = (_a = client === null || client === void 0 ? void 0 : client.typeGroups) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++) {
      var typeGroup = _b[_i];
      var typeKey = getSeatExpansionKey(clientId, typeGroup.locationType);
      typeKeys.push(typeKey);
      for (var _c = 0, _d = typeGroup.locations; _c < _d.length; _c++) {
        var loc = _d[_c];
        var locKey = getSeatExpansionKey(typeKey, loc.locationId);
        locationKeys.push(locKey);
        for (var _e = 0, _f = loc.lobs; _e < _f.length; _e++) {
          var lob = _f[_e];
          lobKeys.push(getSeatExpansionKey(locKey, lob.lobId));
        }
      }
    }
    return {
      typeKeys: typeKeys,
      locationKeys: locationKeys,
      lobKeys: lobKeys
    };
  };
  var getLocationTypeNestedExpansionKeys = function (typeKey) {
    var _a, _b;
    var _c = splitSeatExpansionKey(typeKey),
      clientIdText = _c[0],
      locationTypeParts = _c.slice(1);
    var clientId = Number(clientIdText);
    var locationType = locationTypeParts.join(SEAT_EXPANSION_KEY_SEPARATOR);
    var typeGroup = (_a = clientGroups.find(function (client) {
      return client.clientId === clientId;
    })) === null || _a === void 0 ? void 0 : _a.typeGroups.find(function (item) {
      return item.locationType === locationType;
    });
    var locationKeys = [];
    var lobKeys = [];
    for (var _i = 0, _d = (_b = typeGroup === null || typeGroup === void 0 ? void 0 : typeGroup.locations) !== null && _b !== void 0 ? _b : []; _i < _d.length; _i++) {
      var loc = _d[_i];
      var locKey = getSeatExpansionKey(typeKey, loc.locationId);
      locationKeys.push(locKey);
      for (var _e = 0, _f = loc.lobs; _e < _f.length; _e++) {
        var lob = _f[_e];
        lobKeys.push(getSeatExpansionKey(locKey, lob.lobId));
      }
    }
    return {
      locationKeys: locationKeys,
      lobKeys: lobKeys
    };
  };
  var getLocationNestedExpansionKeys = function (locKey) {
    var _a, _b, _c;
    var _d = splitSeatExpansionKey(locKey),
      clientIdText = _d[0],
      rest = _d.slice(1);
    var locationIdText = rest.at(-1);
    var locationType = rest.slice(0, -1).join(SEAT_EXPANSION_KEY_SEPARATOR);
    var clientId = Number(clientIdText);
    var locationId = Number(locationIdText);
    var loc = (_b = (_a = clientGroups.find(function (client) {
      return client.clientId === clientId;
    })) === null || _a === void 0 ? void 0 : _a.typeGroups.find(function (typeGroup) {
      return typeGroup.locationType === locationType;
    })) === null || _b === void 0 ? void 0 : _b.locations.find(function (location) {
      return location.locationId === locationId;
    });
    return (_c = loc === null || loc === void 0 ? void 0 : loc.lobs.map(function (lob) {
      return getSeatExpansionKey(locKey, lob.lobId);
    })) !== null && _c !== void 0 ? _c : [];
  };
  useEffect(function () {
    if (initializedExpansionStateRef.current || clientGroups.length === 0) return;
    var _a = buildByLocationExpansionFocusKeys(clientGroups, []),
      allTypeKeys = _a.allTypeKeys,
      allLocationKeys = _a.allLocationKeys,
      allLobKeys = _a.allLobKeys;
    initializedExpansionStateRef.current = true;
    setCollapsedTypes(new Set(allTypeKeys));
    setCollapsedLocations(new Set(allLocationKeys));
    setCollapsedLobLeafs(new Set(allLobKeys));
  }, [clientGroups]);
  useEffect(function () {
    if (!(expansionFocus === null || expansionFocus === void 0 ? void 0 : expansionFocus.version)) return;
    if (appliedExpansionFocusVersionRef.current === expansionFocus.version) return;
    var focusClientIds = new Set(expansionFocus.allocations.map(function (allocation) {
      return allocation.clientId;
    }));
    var _a = buildByLocationExpansionFocusKeys(clientGroups, expansionFocus.allocations),
      focusTypeKeys = _a.focusTypeKeys,
      focusLocationKeys = _a.focusLocationKeys,
      focusLobKeys = _a.focusLobKeys,
      allTypeKeys = _a.allTypeKeys,
      allLocationKeys = _a.allLocationKeys,
      allLobKeys = _a.allLobKeys;
    if (focusLobKeys.size === 0) return;
    appliedExpansionFocusVersionRef.current = expansionFocus.version;
    setCollapsedClients(new Set(clientGroups.filter(function (client) {
      return !focusClientIds.has(client.clientId);
    }).map(function (client) {
      return client.clientId;
    })));
    setCollapsedTypes(new Set(allTypeKeys.filter(function (key) {
      return !focusTypeKeys.has(key);
    })));
    setCollapsedLocations(new Set(allLocationKeys.filter(function (key) {
      return !focusLocationKeys.has(key);
    })));
    setCollapsedLobLeafs(new Set(allLobKeys.filter(function (key) {
      return !focusLobKeys.has(key);
    })));
  }, [clientGroups, expansionFocus]);
  var toggleLocationClient = function (clientId) {
    var wasCollapsed = collapsedClients.has(clientId);
    setCollapsedClients(function (prev) {
      var next = new Set(prev);
      next.has(clientId) ? next.delete(clientId) : next.add(clientId);
      return next;
    });
    if (wasCollapsed) {
      var nestedExpansionKeys_3 = getLocationClientNestedExpansionKeys(clientId);
      setCollapsedTypes(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_3.typeKeys);
      });
      setCollapsedLocations(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_3.locationKeys);
      });
      setCollapsedLobLeafs(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_3.lobKeys);
      });
    }
  };
  var toggleLocationType = function (typeKey) {
    var wasCollapsed = collapsedTypes.has(typeKey);
    setCollapsedTypes(function (prev) {
      var next = new Set(prev);
      next.has(typeKey) ? next.delete(typeKey) : next.add(typeKey);
      return next;
    });
    if (wasCollapsed) {
      var nestedExpansionKeys_4 = getLocationTypeNestedExpansionKeys(typeKey);
      setCollapsedLocations(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_4.locationKeys);
      });
      setCollapsedLobLeafs(function (prev) {
        return addItemsToSet(prev, nestedExpansionKeys_4.lobKeys);
      });
    }
  };
  var toggleLocation = function (locKey) {
    var wasCollapsed = collapsedLocations.has(locKey);
    setCollapsedLocations(function (prev) {
      var next = new Set(prev);
      next.has(locKey) ? next.delete(locKey) : next.add(locKey);
      return next;
    });
    if (wasCollapsed) {
      setCollapsedLobLeafs(function (prev) {
        return addItemsToSet(prev, getLocationNestedExpansionKeys(locKey));
      });
    }
  };
  var renderByLocLocation = function (typeKey, clientId, loc) {
    var locKey = getSeatExpansionKey(typeKey, loc.locationId);
    var locExpanded = !collapsedLocations.has(locKey);
    var hasLobs = loc.lobs.length > 0;
    var cap = capacity.find(function (c) {
      return c.locationId === loc.locationId;
    });
    var availableSeatsDisplay;
    if (!cap) {
      availableSeatsDisplay = '—';
    } else if (cap.availableSeats === null) {
      availableSeatsDisplay = t('unlimited', {
        defaultValue: 'Unlimited'
      });
    } else {
      availableSeatsDisplay = formatNumberByLocale(cap.availableSeats);
    }
    return _jsxs(Fragment, {
      children: [_jsxs(TableRow, __assign({
        sx: {
          bgcolor: TABLE_HIERARCHY_COLORS.lightGray
        }
      }, {
        children: [_jsx(TableCell, __assign({
          sx: {
            pl: TABLE_HIERARCHY_INDENTS[3],
            fontWeight: 600
          }
        }, {
          children: _jsx(ExpandableRowLabel, __assign({
            expanded: locExpanded,
            onToggle: hasLobs ? function () {
              return toggleLocation(locKey);
            } : undefined
          }, {
            children: loc.locationName
          }))
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: {
            fontWeight: 600
          }
        }, {
          children: formatNumberByLocale(loc.reservedSeats)
        })), _jsx(TableCell, {}), _jsx(TableCell, __assign({
          align: "center",
          sx: {
            fontWeight: 600
          }
        }, {
          children: loc.totalSeats === null ? t('unlimited', {
            defaultValue: 'Unlimited'
          }) : formatNumberByLocale(loc.totalSeats)
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: {
            fontWeight: 600
          }
        }, {
          children: availableSeatsDisplay
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: {
            fontWeight: 600
          }
        }, {
          children: cap ? "".concat(formatNumberByLocale(cap.utilizationPercentage), "%") : '—'
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: _jsx(DeleteSiteButton, {
            allocationIds: loc.lobs.flatMap(function (l) {
              return l.subLobs.map(function (s) {
                return s.allocationId;
              });
            }),
            onDelete: onDeleteSite
          })
        }))]
      })), hasLobs && locExpanded && loc.lobs.map(function (lob) {
        var _a;
        var lobKey = getSeatExpansionKey(locKey, lob.lobId);
        var lobExpanded = !collapsedLobLeafs.has(lobKey);
        var hasSubLobs = lob.subLobs.some(function (s) {
          return s.subLobId !== null;
        });
        var singleBuffer = (_a = lob.subLobs[0]) === null || _a === void 0 ? void 0 : _a.bufferPercent;
        var singleBufferLabel = formatBufferPercent(singleBuffer);
        var bufferCell = hasSubLobs ? '' : singleBufferLabel;
        return _jsxs(Fragment, {
          children: [_jsxs(TableRow, {
            children: [_jsx(TableCell, __assign({
              sx: {
                pl: TABLE_HIERARCHY_INDENTS[4]
              }
            }, {
              children: _jsx(ExpandableRowLabel, __assign({
                expanded: lobExpanded,
                onToggle: hasSubLobs ? function () {
                  return toggleSetItem(setCollapsedLobLeafs, lobKey);
                } : undefined
              }, {
                children: lob.lobName
              }))
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: formatNumberByLocale(lob.reservedSeats)
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: bufferCell
            })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {})]
          }), hasSubLobs && lobExpanded && lob.subLobs.map(function (subLob) {
            var _a;
            return _jsxs(TableRow, {
              children: [_jsx(TableCell, __assign({
                sx: {
                  pl: TABLE_HIERARCHY_INDENTS[5]
                }
              }, {
                children: (_a = subLob.subLobName) !== null && _a !== void 0 ? _a : t('noSubLob', {
                  defaultValue: '(No sub-line of business)'
                })
              })), _jsx(TableCell, __assign({
                align: "center"
              }, {
                children: formatNumberByLocale(subLob.reservedSeats)
              })), _jsx(TableCell, __assign({
                align: "center"
              }, {
                children: formatBufferPercent(subLob.bufferPercent)
              })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {})]
            }, getSeatExpansionKey(lobKey, 'sub', subLob.allocationId));
          })]
        }, lobKey);
      })]
    }, locKey);
  };
  if (!clientGroups.length) {
    return _jsx(TableRow, {
      children: _jsx(TableCell, __assign({
        colSpan: 7,
        align: "center",
        sx: {
          color: 'text.secondary',
          py: 4
        }
      }, {
        children: t('noData', {
          defaultValue: 'No data to display'
        })
      }))
    });
  }
  return _jsx(_Fragment, {
    children: clientGroups.map(function (client) {
      var clientExpanded = !collapsedClients.has(client.clientId);
      return _jsxs(Fragment, {
        children: [_jsxs(TableRow, __assign({
          sx: {
            bgcolor: 'primary.light'
          }
        }, {
          children: [_jsx(TableCell, __assign({
            sx: {
              pl: TABLE_HIERARCHY_INDENTS[1],
              fontWeight: 'bold'
            }
          }, {
            children: _jsx(ExpandableRowLabel, __assign({
              expanded: clientExpanded,
              onToggle: function () {
                return toggleLocationClient(client.clientId);
              },
              bold: true
            }, {
              children: _jsx(MuiLink, __assign({
                component: "button",
                sx: {
                  fontWeight: 'bold'
                },
                onClick: function (e) {
                  e.stopPropagation();
                  onEditClient(client.clientId);
                }
              }, {
                children: client.clientName
              }))
            }))
          })), _jsx(TableCell, __assign({
            align: "center",
            sx: {
              fontWeight: 'bold'
            }
          }, {
            children: formatNumberByLocale(client.reservedSeats)
          })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {})]
        }), "client-".concat(client.clientId)), clientExpanded && client.typeGroups.map(function (typeGroup) {
          var typeKey = getSeatExpansionKey(client.clientId, typeGroup.locationType);
          var typeExpanded = !collapsedTypes.has(typeKey);
          var hasLocations = typeGroup.locations.length > 0;
          return _jsxs(Fragment, {
            children: [_jsxs(TableRow, __assign({
              sx: {
                bgcolor: TABLE_HIERARCHY_COLORS.lightBlueGray
              }
            }, {
              children: [_jsx(TableCell, __assign({
                sx: {
                  pl: TABLE_HIERARCHY_INDENTS[2]
                }
              }, {
                children: _jsx(ExpandableRowLabel, __assign({
                  expanded: typeExpanded,
                  onToggle: hasLocations ? function () {
                    return toggleLocationType(typeKey);
                  } : undefined
                }, {
                  children: _jsx(LocationTypeLabel, {
                    locationType: typeGroup.locationType
                  })
                }))
              })), _jsx(TableCell, __assign({
                align: "center"
              }, {
                children: formatNumberByLocale(typeGroup.reservedSeats)
              })), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {}), _jsx(TableCell, {})]
            }), typeKey), typeExpanded && typeGroup.locations.map(function (loc) {
              return renderByLocLocation(typeKey, client.clientId, loc);
            })]
          }, typeKey);
        })]
      }, "client-".concat(client.clientId));
    })
  });
}
export var SeatsStep = function () {
  var _a, _b, _c, _d, _e, _f;
  var _g = useContext(OrgConfigWizardContext),
    configVersionId = _g.configVersionId,
    isBpo = _g.isBpo,
    setBeforeNext = _g.setBeforeNext;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'seats'
  }).t;
  var nextLocationRowIdRef = useRef(0);
  var makeEmptyLocationRow = function () {
    return {
      id: ++nextLocationRowIdRef.current,
      locationId: 0,
      seats: ''
    };
  };
  var _h = useState('client'),
    viewMode = _h[0],
    setViewMode = _h[1];
  var _j = useState({
      clientId: '',
      lobId: '',
      subLobId: '',
      locationRows: [makeEmptyLocationRow()]
    }),
    form = _j[0],
    setForm = _j[1];
  var _k = useState(''),
    bufferPercent = _k[0],
    setBufferPercent = _k[1];
  var _l = useState(null),
    formError = _l[0],
    setFormError = _l[1];
  var _m = useState(null),
    confirmDeleteIds = _m[0],
    setConfirmDeleteIds = _m[1];
  var _o = useState(false),
    pendingDelete = _o[0],
    setPendingDelete = _o[1];
  var _p = useState(null),
    seatExpansionFocus = _p[0],
    setSeatExpansionFocus = _p[1];
  var _q = useClientsAPI(configVersionId),
    clientsData = _q[0],
    fetchClients = _q[1];
  var _r = useLocationsAPI(configVersionId),
    locationsData = _r[0],
    fetchLocations = _r[1];
  var _s = useClientLobsAPI(Number(form.clientId) || null, 'orgConfigSeatsLobs'),
    lobsData = _s[0],
    fetchLobs = _s[1];
  var _t = useSeatAllocationsByClientAPI(configVersionId),
    byClientData = _t[0],
    fetchByClient = _t[1];
  var _u = useSeatAllocationsByLocationAPI(configVersionId),
    byLocationData = _u[0],
    fetchByLocation = _u[1];
  var _v = useSeatsCapacityAPI(configVersionId),
    capacityData = _v[0],
    fetchCapacity = _v[1];
  var _w = useBatchCreateSeatAllocationAPI(),
    batchCreateData = _w[0],
    batchCreateAllocations = _w[1],
    clearBatchCreate = _w[2];
  var _x = useBatchDeleteSeatAllocationAPI(),
    batchDeleteData = _x[0],
    batchDeleteAllocations = _x[1],
    clearBatchDelete = _x[2];
  var store = useStore();
  var formRef = useRef(form);
  var bufferPercentRef = useRef(bufferPercent);
  var batchCreateAllocationsRef = useRef(batchCreateAllocations);
  var pendingSeatAllocationsRef = useRef([]);
  var seatExpansionFocusVersionRef = useRef(0);
  useEffect(function () {
    formRef.current = form;
  }, [form]);
  useEffect(function () {
    bufferPercentRef.current = bufferPercent;
  }, [bufferPercent]);
  useEffect(function () {
    batchCreateAllocationsRef.current = batchCreateAllocations;
  }, [batchCreateAllocations]);
  var _y = useDialog(),
    dialogMode = _y.dialogMode,
    dialogData = _y.data,
    handleOpenDialog = _y.handleOpenDialog,
    handleCloseDialog = _y.handleCloseDialog;
  var clients = useMemo(function () {
    var _a;
    return (_a = clientsData.data) !== null && _a !== void 0 ? _a : [];
  }, [clientsData.data]);
  var locations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  var lobs = useMemo(function () {
    var _a;
    return (_a = lobsData.data) !== null && _a !== void 0 ? _a : [];
  }, [lobsData.data]);
  var hqClient = useMemo(function () {
    return clients.find(function (c) {
      return c.isHqClient;
    });
  }, [clients]);
  var selectedLob = useMemo(function () {
    return lobs.find(function (l) {
      return l.id === Number(form.lobId);
    });
  }, [lobs, form.lobId]);
  var subLobs = (_a = selectedLob === null || selectedLob === void 0 ? void 0 : selectedLob.subLobs) !== null && _a !== void 0 ? _a : [];
  // A LOB is mandatory for a seat reservation (org_seat_allocation.lob_id is NOT NULL), so a client
  // with no LOB can't reserve seats. Surface that as actionable guidance instead of the generic
  // "required fields" error the user would otherwise hit with the (correctly) disabled LOB dropdown.
  var clientHasNoLob = !!form.clientId && !lobsData.requesting && lobs.length === 0;
  var refresh = useCallback(function () {
    if (!configVersionId) return;
    fetchByClient();
    fetchByLocation();
    fetchCapacity();
  }, [configVersionId, fetchByClient, fetchByLocation, fetchCapacity]);
  useEffect(function () {
    if (configVersionId) {
      fetchClients();
      fetchLocations();
      fetchByClient();
      fetchByLocation();
      fetchCapacity();
    }
  }, [configVersionId, fetchClients, fetchLocations, fetchByClient, fetchByLocation, fetchCapacity]);
  useEffect(function () {
    if (!isBpo && hqClient) {
      setForm(function (f) {
        return __assign(__assign({}, f), {
          clientId: hqClient.id
        });
      });
    }
  }, [isBpo, hqClient]);
  useEffect(function () {
    if (form.clientId) fetchLobs();
    setForm(function (f) {
      return __assign(__assign({}, f), {
        lobId: '',
        subLobId: ''
      });
    });
  }, [form.clientId, fetchLobs]);
  useEffect(function () {
    setForm(function (f) {
      return __assign(__assign({}, f), {
        subLobId: ''
      });
    });
  }, [form.lobId]);
  useEffect(function () {
    if (batchCreateData.data) {
      setSeatExpansionFocus({
        version: ++seatExpansionFocusVersionRef.current,
        allocations: pendingSeatAllocationsRef.current
      });
      pendingSeatAllocationsRef.current = [];
      refresh();
      setForm(function (f) {
        return __assign(__assign({}, f), {
          lobId: '',
          subLobId: '',
          locationRows: [makeEmptyLocationRow()]
        });
      });
      setBufferPercent('');
      setFormError(null);
      clearBatchCreate();
    }
    return function () {
      clearBatchCreate();
    };
  }, [batchCreateData.data, refresh, clearBatchCreate]);
  useEffect(function () {
    if (!pendingDelete) return;
    if (batchDeleteData.requesting === false) {
      setPendingDelete(false);
      if (!batchDeleteData.error) {
        clearBatchDelete();
        refresh();
      }
    }
  }, [pendingDelete, batchDeleteData.requesting, batchDeleteData.error, clearBatchDelete, refresh]);
  var buildAllocations = function (f, bp, cvId) {
    var subLobId = f.subLobId === '' ? null : Number(f.subLobId);
    var seenLocationIds = new Set();
    return f.locationRows.filter(function (r) {
      return r.locationId > 0 && r.seats !== '';
    }).filter(function (r) {
      // The client/LOB/sub-LOB are fixed per submission, so a repeated location would be a
      // duplicate allocation. Keep the first occurrence and drop the rest before submitting.
      if (seenLocationIds.has(r.locationId)) return false;
      seenLocationIds.add(r.locationId);
      return true;
    }).map(function (row) {
      return {
        configVersionId: cvId,
        clientId: Number(f.clientId),
        lobId: Number(f.lobId),
        subLobId: subLobId,
        locationId: row.locationId,
        allocatedSeats: Number(row.seats),
        bufferPercent: bp === '' ? null : Number(bp)
      };
    });
  };
  var handleDeleteSite = function (allocationIds) {
    if (!allocationIds.length) return;
    setConfirmDeleteIds(allocationIds);
  };
  var handleConfirmDelete = function () {
    if (!(confirmDeleteIds === null || confirmDeleteIds === void 0 ? void 0 : confirmDeleteIds.length)) return;
    setPendingDelete(true);
    batchDeleteAllocations({
      ids: confirmDeleteIds
    });
    setConfirmDeleteIds(null);
  };
  useEffect(function () {
    var beforeNextFn = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var f, validRows, seatsOutOfRange, allocations, trigger;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              f = formRef.current;
              validRows = f.locationRows.filter(function (r) {
                return r.locationId > 0 && r.seats !== '';
              });
              if (!f.clientId || !f.lobId || !validRows.length) return [2 /*return*/, true];
              seatsOutOfRange = validRows.some(function (r) {
                return Number(r.seats) < MIN_ALLOCATED_SEATS || Number(r.seats) > MAX_ALLOCATED_SEATS;
              });
              if (seatsOutOfRange) {
                setFormError(t('validation.seatsRange', {
                  min: formatNumberByLocale(MIN_ALLOCATED_SEATS),
                  max: formatNumberByLocale(MAX_ALLOCATED_SEATS),
                  defaultValue: 'Number of seats must be between {{min}} and {{max}}.'
                }));
                return [2 /*return*/, false];
              }
              allocations = buildAllocations(f, bufferPercentRef.current, configVersionId);
              pendingSeatAllocationsRef.current = allocations;
              trigger = function () {
                return batchCreateAllocationsRef.current({
                  allocations: allocations
                });
              };
              return [4 /*yield*/, waitForApiSliceTerminal(store, 'orgConfigSeatBatchCreate:POST', trigger)];
            case 1:
              _a.sent();
              return [2 /*return*/, true];
          }
        });
      });
    };
    setBeforeNext(beforeNextFn);
    return function () {
      return setBeforeNext(null);
    };
  }, [store, configVersionId, setBeforeNext, t]);
  var initialAllocationsRef = useRef(null);
  useEffect(function () {
    if (byClientData.data && !initialAllocationsRef.current) {
      initialAllocationsRef.current = byClientData.data;
    }
  }, [byClientData.data]);
  var checkIsDirty = useCallback(function () {
    var f = formRef.current;
    var validRows = f.locationRows.filter(function (r) {
      return r.locationId > 0 && r.seats !== '';
    });
    var isFormDirty = !!(f.clientId && f.lobId && validRows.length);
    var isListDirty = initialAllocationsRef.current ? JSON.stringify(byClientData.data) !== JSON.stringify(initialAllocationsRef.current) : false;
    return isFormDirty || isListDirty;
  }, [byClientData.data]);
  useOrgConfigDirtyRegister(checkIsDirty);
  var handleAddLocationRow = function () {
    setForm(function (f) {
      return __assign(__assign({}, f), {
        locationRows: __spreadArray(__spreadArray([], f.locationRows, true), [makeEmptyLocationRow()], false)
      });
    });
  };
  var handleRemoveLocationRow = function (index) {
    setForm(function (f) {
      // Always keep at least one row: if removing the last remaining row, reset it to empty.
      if (f.locationRows.length <= 1) {
        return __assign(__assign({}, f), {
          locationRows: [makeEmptyLocationRow()]
        });
      }
      return __assign(__assign({}, f), {
        locationRows: f.locationRows.filter(function (_, i) {
          return i !== index;
        })
      });
    });
  };
  var handleLocationChange = function (index, field, value) {
    setForm(function (f) {
      var _a;
      var rows = __spreadArray([], f.locationRows, true);
      rows[index] = __assign(__assign({}, rows[index]), (_a = {}, _a[field] = value, _a));
      return __assign(__assign({}, f), {
        locationRows: rows
      });
    });
  };
  var handleReserveSeats = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var validRows, seatsOutOfRange, allocations;
      return __generator(this, function (_a) {
        if (clientHasNoLob) {
          setFormError(t('validation.noLob', {
            defaultValue: 'This company/client has no Line of Business yet. Add one in the Clients step before reserving seats.'
          }));
          return [2 /*return*/];
        }
        if (!configVersionId || !form.clientId || !form.lobId) {
          setFormError(t('validation.requiredFields', {
            defaultValue: 'Please fill in all required fields.'
          }));
          return [2 /*return*/];
        }
        validRows = form.locationRows.filter(function (r) {
          return r.locationId > 0 && r.seats !== '';
        });
        if (!validRows.length) {
          setFormError(t('validation.locationRequired', {
            defaultValue: 'Please select at least one location and enter a seat count.'
          }));
          return [2 /*return*/];
        }
        seatsOutOfRange = validRows.some(function (r) {
          return Number(r.seats) < MIN_ALLOCATED_SEATS || Number(r.seats) > MAX_ALLOCATED_SEATS;
        });
        if (seatsOutOfRange) {
          setFormError(t('validation.seatsRange', {
            min: formatNumberByLocale(MIN_ALLOCATED_SEATS),
            max: formatNumberByLocale(MAX_ALLOCATED_SEATS),
            defaultValue: 'Number of seats must be between {{min}} and {{max}}.'
          }));
          return [2 /*return*/];
        }
        setFormError(null);
        allocations = buildAllocations(form, bufferPercent, configVersionId);
        pendingSeatAllocationsRef.current = allocations;
        batchCreateAllocations({
          allocations: allocations
        });
        return [2 /*return*/];
      });
    });
  };
  var byClientRows = (_b = byClientData.data) !== null && _b !== void 0 ? _b : [];
  var byLocationRows = (_c = byLocationData.data) !== null && _c !== void 0 ? _c : [];
  var editModalClientId = dialogMode === DialogMode.EditClient ? (_d = dialogData === null || dialogData === void 0 ? void 0 : dialogData.clientId) !== null && _d !== void 0 ? _d : null : null;
  return _jsxs(FallbackComponent, __assign({
    requesting: clientsData.requesting
  }, {
    children: [_jsx(OrgConfigStepContainer, __assign({
      leftMd: 4,
      spacing: 3,
      leftContent: _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(Typography, __assign({
          variant: "h6",
          fontWeight: "bold"
        }, {
          children: t('formTitle', {
            defaultValue: 'Seat Allocation'
          })
        })), _jsx(UnControlledFormField, __assign({
          label: t('client', {
            defaultValue: 'Company/Client'
          }),
          required: isBpo
        }, {
          children: isBpo ? _jsx(Autocomplete, {
            options: clients.map(function (c) {
              return {
                id: c.id,
                name: c.clientName
              };
            }),
            placeholder: t('pleaseSelect', {
              defaultValue: 'Please select'
            }),
            value: form.clientId || undefined,
            onChange: function (value) {
              setFormError(null);
              setForm(function (f) {
                return __assign(__assign({}, f), {
                  clientId: value !== null && value !== void 0 ? value : '',
                  lobId: '',
                  subLobId: '',
                  locationRows: [makeEmptyLocationRow()]
                });
              });
            }
          }) : _jsx(TextField, {
            fullWidth: true,
            size: "small",
            value: (_e = hqClient === null || hqClient === void 0 ? void 0 : hqClient.clientName) !== null && _e !== void 0 ? _e : '',
            disabled: true,
            InputProps: {
              readOnly: true
            },
            sx: {
              bgcolor: 'action.disabledBackground'
            }
          })
        })), _jsx(UnControlledFormField, __assign({
          label: t('bufferPercent', {
            defaultValue: '% buffer'
          })
        }, {
          children: _jsx(NumberInput, {
            fullWidth: true,
            size: "small",
            min: 0,
            max: 100,
            decimal: 2,
            value: bufferPercent === '' ? null : Number(bufferPercent),
            onChange: function (v) {
              return setBufferPercent(v == null ? '' : String(v));
            },
            placeholder: t('placeholderZero', {
              defaultValue: '0'
            })
          })
        })), _jsx(UnControlledFormField, __assign({
          label: t('lob', {
            defaultValue: 'Line(s) of Business'
          }),
          required: true
        }, {
          children: _jsx(Autocomplete, {
            options: lobs.map(function (l) {
              return {
                id: l.id,
                name: l.lobName
              };
            }),
            placeholder: t('pleaseSelect', {
              defaultValue: 'Please select'
            }),
            value: form.lobId || undefined,
            onChange: function (value) {
              return setForm(function (f) {
                return __assign(__assign({}, f), {
                  lobId: value !== null && value !== void 0 ? value : ''
                });
              });
            },
            disabled: !form.clientId || lobs.length === 0
          })
        })), clientHasNoLob && _jsx(Typography, __assign({
          variant: "caption",
          color: "text.secondary",
          sx: {
            mt: -1
          }
        }, {
          children: t('noLobHint', {
            defaultValue: 'No Line of Business found. Add one in the Clients step to reserve seats.'
          })
        })), _jsx(UnControlledFormField, __assign({
          label: t('subLob', {
            defaultValue: 'Sub Line(s) of Business'
          })
        }, {
          children: _jsx(Autocomplete, {
            options: subLobs.map(function (s) {
              return {
                id: s.id,
                name: s.subLobName
              };
            }),
            placeholder: t('pleaseSelect', {
              defaultValue: 'Please select'
            }),
            value: form.subLobId || undefined,
            onChange: function (value) {
              return setForm(function (f) {
                return __assign(__assign({}, f), {
                  subLobId: value !== null && value !== void 0 ? value : ''
                });
              });
            },
            disabled: !form.lobId || subLobs.length === 0,
            disableClearable: false
          })
        })), form.locationRows.map(function (row, i) {
          return _jsxs(Stack, __assign({
            direction: "row",
            gap: 1,
            alignItems: "flex-end"
          }, {
            children: [_jsxs(Stack, __assign({
              direction: "column",
              sx: {
                flex: 1,
                minWidth: 0
              }
            }, {
              children: [i === 0 && _jsxs(Typography, __assign({
                variant: "subtitle2",
                fontWeight: 600,
                sx: {
                  mb: 0.5
                }
              }, {
                children: [t('location', {
                  defaultValue: 'Site Location Name'
                }), _jsx(Typography, __assign({
                  component: "span",
                  color: "error.main",
                  sx: {
                    ml: '2px'
                  }
                }, {
                  children: "*"
                }))]
              })), _jsx(Autocomplete, {
                options: locations.map(function (loc) {
                  return {
                    id: loc.id,
                    name: loc.locationName
                  };
                }),
                placeholder: t('selectLocation', {
                  defaultValue: 'Select a location'
                }),
                value: row.locationId || undefined,
                onChange: function (value) {
                  return handleLocationChange(i, 'locationId', value ? Number(value) : '');
                },
                renderOption: function (props, option) {
                  var _a;
                  var loc = locations.find(function (l) {
                    return l.id === option.id;
                  });
                  if (!loc) return _jsx("li", __assign({}, props, {
                    children: option.name
                  }));
                  var cap = (_a = capacityData.data) === null || _a === void 0 ? void 0 : _a.find(function (c) {
                    return c.locationId === loc.id;
                  });
                  var locationSuffix = '';
                  if (loc.totalSeats === null) {
                    locationSuffix = " (".concat(t('unlimited', {
                      defaultValue: 'Unlimited'
                    }), ")");
                  } else if (cap) {
                    var availableText = cap.availableSeats === null ? t('unlimited', {
                      defaultValue: 'Unlimited'
                    }) : "".concat(cap.availableSeats, " available");
                    locationSuffix = " (".concat(availableText, ")");
                  }
                  return _jsxs("li", __assign({}, props, {
                    children: [option.name, locationSuffix]
                  }));
                }
              })]
            })), _jsxs(Stack, __assign({
              direction: "column",
              sx: {
                width: 90
              }
            }, {
              children: [i === 0 && _jsxs(Typography, __assign({
                variant: "subtitle2",
                fontWeight: 600,
                sx: {
                  mb: 0.5
                }
              }, {
                children: [t('seats', {
                  defaultValue: '# of seats'
                }), _jsx(Typography, __assign({
                  component: "span",
                  color: "error.main",
                  sx: {
                    ml: '2px'
                  }
                }, {
                  children: "*"
                }))]
              })), _jsx(NumberInput, {
                size: "small",
                min: 0,
                max: MAX_ALLOCATED_SEATS,
                value: row.seats === '' ? null : Number(row.seats),
                onChange: function (v) {
                  return handleLocationChange(i, 'seats', v == null ? '' : Number(v));
                },
                fullWidth: true
              })]
            })), _jsx(Stack, __assign({
              direction: "column-reverse",
              alignItems: "center",
              sx: {
                flexShrink: 0,
                alignSelf: 'stretch'
              }
            }, {
              children: _jsx(Box, __assign({
                sx: {
                  display: 'flex',
                  alignItems: 'center',
                  height: 40
                }
              }, {
                children: _jsx(IconButton, __assign({
                  size: "small",
                  onClick: function () {
                    return handleRemoveLocationRow(i);
                  },
                  disabled: i === 0,
                  "aria-label": "delete",
                  sx: {
                    color: function (theme) {
                      return theme.palette.text.primary;
                    },
                    '&:hover': {
                      color: function (theme) {
                        return theme.palette.text.primary;
                      },
                      backgroundColor: function (theme) {
                        return theme.palette.action.hover;
                      }
                    }
                  }
                }, {
                  children: _jsx(FontAwesomeIcon, {
                    icon: "trash-can"
                  })
                }))
              }))
            }))]
          }), row.id);
        }), _jsx(MuiLink, __assign({
          component: "button",
          onClick: handleAddLocationRow,
          sx: {
            width: 'fit-content'
          }
        }, {
          children: t('addLocation', {
            defaultValue: '+ Assign seats to another site location'
          })
        })), formError && _jsx(Typography, __assign({
          color: "error",
          variant: "caption"
        }, {
          children: formError
        })), batchCreateData.error && _jsx(ErrorMessageBox, {
          errors: [batchCreateData.error]
        }), _jsx(Button, __assign({
          variant: "outlined",
          fullWidth: true,
          onClick: handleReserveSeats,
          disabled: batchCreateData.requesting,
          sx: {
            textTransform: 'uppercase',
            fontWeight: 600
          }
        }, {
          children: t('reserveSeats', {
            defaultValue: 'Reserve Seats'
          })
        }))]
      }))
    }, {
      children: _jsxs(Stack, __assign({
        spacing: 3
      }, {
        children: [_jsxs(Stack, __assign({
          direction: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }, {
          children: [_jsx(Typography, __assign({
            variant: "h6",
            fontWeight: "bold"
          }, {
            children: t('inventoryTitle', {
              defaultValue: 'Seat Inventory'
            })
          })), _jsx(Autocomplete, {
            options: [{
              id: 'client',
              name: t('viewByClient', {
                defaultValue: 'View by company/client'
              })
            }, {
              id: 'location',
              name: t('viewByLocation', {
                defaultValue: 'View by site location'
              })
            }],
            value: viewMode,
            onChange: function (value) {
              return setViewMode(value || viewMode);
            },
            sx: {
              width: '16rem'
            }
          })]
        })), _jsx(WizardTable, __assign({
          headers: viewMode === 'client' ? _jsxs(_Fragment, {
            children: [_jsx(TableCell, {
              children: t('table.client', {
                defaultValue: 'Company/Client'
              })
            }), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.reservedSeats', {
                defaultValue: 'Reserved Seats'
              })
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.bufferPercent', {
                defaultValue: '% buffer'
              })
            })), _jsx(TableCell, {
              align: "center",
              width: 50
            })]
          }) : _jsxs(_Fragment, {
            children: [_jsx(TableCell, {
              children: t('table.location', {
                defaultValue: 'Site Location Name'
              })
            }), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.reservedSeats', {
                defaultValue: 'Reserved Seats'
              })
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.bufferPercent', {
                defaultValue: '% buffer'
              })
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.totalSeats', {
                defaultValue: 'Total Seats'
              })
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.availableSeats', {
                defaultValue: 'Available Seats'
              })
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.utilization', {
                defaultValue: 'Utilization %'
              })
            })), _jsx(TableCell, {
              align: "center",
              width: 50
            })]
          })
        }, {
          children: _jsx(TableBody, {
            children: viewMode === 'client' ? _jsx(ByClientInventory, {
              rows: byClientRows,
              onEditClient: function (clientId) {
                return handleOpenDialog(DialogMode.EditClient, {
                  clientId: clientId
                });
              },
              onDeleteSite: handleDeleteSite,
              expansionFocus: seatExpansionFocus
            }) : _jsx(ByLocationInventory, {
              rows: byLocationRows,
              capacity: (_f = capacityData.data) !== null && _f !== void 0 ? _f : [],
              onEditClient: function (clientId) {
                return handleOpenDialog(DialogMode.EditClient, {
                  clientId: clientId
                });
              },
              onDeleteSite: handleDeleteSite,
              expansionFocus: seatExpansionFocus
            })
          })
        })), batchDeleteData.error && _jsx(ErrorMessageBox, {
          errors: [batchDeleteData.error]
        })]
      }))
    })), _jsx(ConfirmDialog, {
      open: confirmDeleteIds !== null,
      onClose: function () {
        return setConfirmDeleteIds(null);
      },
      title: t('deleteInventoryTitle', {
        defaultValue: 'Delete seat reservation?'
      }),
      message: t('deleteInventoryMessage', {
        defaultValue: 'Are you sure you want to delete all seat reservations for this site location? This cannot be undone.'
      }),
      onConfirm: handleConfirmDelete
    }), editModalClientId !== null && _jsx(SeatAllocationModal, {
      open: true,
      configVersionId: configVersionId,
      clientId: editModalClientId,
      clients: clients,
      onClose: handleCloseDialog,
      onSaved: refresh
    })]
  }));
};